import React, { forwardRef } from 'react'

import { IconProps } from './types'

const Text = forwardRef<SVGSVGElement, IconProps>(
  ({ size, color, ...props }, ref) => (
    <svg
      ref={ref}
      width={props.width ?? size}
      height={props.height ?? size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.5 13.5L9 2.5H8L3.5 13.5H4.5L6 10H11L12.5 13.5H13.5ZM10.5833 9L8.5 3.7L6.41667 9H10.5833Z"
        fill={color || 'currentColor'}
      />
    </svg>
  ),
)
Text.displayName = 'Text'

export default Text
